<script setup lang="ts">
import { inject, onMounted, onUnmounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { onBeforeRouteUpdate } from 'vue-router'

import { $busOff, $busOn } from '@kidzonet/inject-bus-emit'

const announcement = ref('')

const { t, te } = useI18n()

const showAriaTooltip = ({ message, timeout = 0 }: { message: string, timeout?: number }) => {
    setTimeout(() => {
        announcement.value = message
    }, timeout)
}

const busOn = inject($busOn)
const busOff = inject($busOff)

onMounted(() => {
    if (busOn) {
        // @ts-expect-error strange mitt type validation
        busOn('pronounce', showAriaTooltip)
    }
})

onUnmounted(() => {
    if (busOff) {
        // @ts-expect-error strange mitt type validation
        busOff('pronounce', showAriaTooltip)
    }
})

onBeforeRouteUpdate(async (to) => {
    const { title } = to.meta
    if (title && typeof title === 'string' && te(title)) {
        showAriaTooltip({ message: `${t(title)} page was oppened`, timeout: 600 })
    }
})
</script>

<template>
    <div>
        <router-view />
        <div
            aria-live="polite"
            aria-atomic="true"
            role="status"
            class="kidzonet-aria-kive-region"
        >
            {{ announcement }}
        </div>
    </div>
</template>

<style>
    .kidzonet-aria-kive-region {
        position: absolute;

        overflow: hidden;

        inline-size: 1px;
        block-size: 1px;

        white-space: nowrap;

        clip: rect(0 0 0 0);
    }
</style>
